import { clearModal } from '@shoflo/studio-redux/actions';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/Modal';
import { sendToDatadog } from '@shoflo/polymer';

function clearLostRealTimeMessage(dispatch, getState) {
  window.realtimeConnectionLostTimeout = null;
  dispatch(clearModal(LOST_REALTIME_SOCKET_CONNECTION));

  const {
    meeting: { attendeeResponse }
  } = getState();
  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };

  sendToDatadog('socket-dispatcher', payload, 'Realtime socket connected');
}

function socketConnected({ dispatch, getState }) {
  clearLostRealTimeMessage(dispatch, getState);
}

export default socketConnected;
